import React, { Component } from "react";
import axios from "axios";
import Serverurl from "./Apiurl";
import "./styles/styles.css";
import { makeStyles } from '@mui/styles'; 
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";

import "yet-another-react-lightbox/styles.css";
import {
  Container,
  Paper,
  Box,
  Typography,
  Alert,TableFooter,
  CircularProgress
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";





function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'LabourDate', numeric: false, label: 'Date', disablePadding: true },
    { id: 'ProjectName', numeric: false, label: 'Project', disablePadding: true },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, rowCount, dynamicColumns } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
                {dynamicColumns.map(col => (
                    <TableCell
                        key={col}
                        align="right"
                        padding="none"
                    >
                        {col}
                    </TableCell>
                ))}
                <TableCell
                    align="right"
                    padding="none"
                >
                    <b>Grand Total</b>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    dynamicColumns: PropTypes.array.isRequired,
};


const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});




export default class ProjectDetails extends Component {

    constructor(props){
        super(props);

        this.state={
            projectId:"",
            projectData:{},
            activeTab:"wages"
        }
    }


componentWillMount() {
	  if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }

let strname="Project";   
			 this.props.parentsCallback(
           strname
        );
  const userid = localStorage.getItem("VRuserid");

}






    componentDidMount(){

        const params=new URLSearchParams(window.location.search);
        const projectId=params.get("projectId");

        this.setState({projectId},()=>{
			
			
			axios.get(Serverurl+"ajaxprojects.php?action=getall&pj_id="+projectId)
        .then(res=>{

            if(res.data.length>0){

                this.setState({
                    projectData:res.data[0]
                });

             

            }

        });
			
		});

        

    }

    render(){

        return(

            <React.Fragment>

                {/* Project Card */}

                <div className="txtprojfrm">

                    <h2>{this.state.projectData.pj_projectname}</h2>

                    <p>
                        Phone : {this.state.projectData.pj_phoneno}
                    </p>

                    <p>
                        Address : {this.state.projectData.pj_address}
                    </p>

                </div>
				<div className="txtprojfrmryt">
				
				<p >Finalised Amount <br/><span className="finalamount">Rs.{parseFloat(this.state.projectData.pj_finalizedamount).toLocaleString("en-IN")}</span></p>
				</div>
<div className="clear"></div>
                {/* Tabs */}

               <div>

  {/* TABS HEADER */}
  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
    <Tabs
      value={this.state.activeTab}
      onChange={(event, newValue) =>
        this.setState({ activeTab: newValue })
      }
    >
      <Tab label="Wages" value="wages" />
	   <Tab label="Services" value="services" />
      <Tab label="Materials" value="materials" />
      <Tab label="Gallery" value="gallery" />
      <Tab label="Expense" value="expense" />
	  <Tab label="Payment In" value="paymentin" />
      <Tab label="Payment Out" value="paymentout" />
    </Tabs>
  </Box>

  {/* TAB CONTENT */}
  {this.state.activeTab === "wages" && (
    <WagesReport projectId={this.state.projectId} />
  )}

  {this.state.activeTab === "materials" && (
    <Materials projectId={this.state.projectId} />
  )}

  {this.state.activeTab === "gallery" && (
    <Gallery projectId={this.state.projectId} />
  )}

  {this.state.activeTab === "expense" && (
    <ExpensesReport projectId={this.state.projectId} />
  )}  {this.state.activeTab === "paymentin" && (
    <Paymentin projectId={this.state.projectId} />
  )}
  {this.state.activeTab === "paymentout" && (
    <Paymentout projectId={this.state.projectId} />
  )}
   {this.state.activeTab === "services" && (
    <Services projectId={this.state.projectId} />
  )}

</div>
            </React.Fragment>

        )

    }

}


export class WagesReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reportData: [],
            projectId: props.projectId,
            loading: false,
            error: "",
            page: 0,
            rowsPerPage: 10,
            order: "desc",
            orderBy: "LabourDate",
            dynamicColumns: [],
            totalRecords: 0,
            grandTotalAmount: 0
        };
    }

    componentDidMount() {

        if (this.props.projectId) {

            this.setState(
                {
                    projectId: this.props.projectId
                },
                () => {
                    this.apicall();
                }
            );

        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.projectId !== this.props.projectId) {

            this.setState(
                {
                    projectId: this.props.projectId,
                    page: 0
                },
                () => {
                    this.apicall();
                }
            );

        }

    }

    apicall = () => {

        this.setState({
            loading: true,
            error: ""
        });

         const projectId = this.props.projectId;

    if (!projectId) return;

  

    axios.get(
        Serverurl +
        "ajaxlaborexpensesreport.php?action=getlabourreport" +

        "&project_id=" + projectId +
        "&index=" + this.state.page +
        "&maxrecrd=" + this.state.rowsPerPage +
        "&orderby=" + this.state.orderBy +
        "&order=" + this.state.order
    )
        .then((resp) => {

            const data = Array.isArray(resp.data)
                ? resp.data
                : [];

            let grandTotalAmount = 0;

            data.forEach((item) => {

                grandTotalAmount += Number(
                    item.GrandTotalAmount || 0
                );

            });

            let dynamicColumns = [];

            if (data.length > 0) {

                dynamicColumns = Object.keys(data[0]).filter(

                    key =>
                        ![
                            "count",
                            "LabourDate",
                            "ProjectName",
                            "GrandTotalAmount"
                        ].includes(key)

                );

            }

            this.setState({

                reportData: data,
                dynamicColumns,
                grandTotalAmount,
                totalRecords: parseInt(
                    data[0]?.count || data.length
                ),
                loading: false

            });

        })
        .catch(() => {

            this.setState({

                loading: false,
                error: "Unable to load wages."

            });

        });

    };

    handleRequestSort = (event, property) => {

        const isAsc =
            this.state.orderBy === property &&
            this.state.order === "asc";

        this.setState(
            {

                orderBy: property,
                order: isAsc ? "desc" : "asc"

            },
            () => {

                this.apicall();

            }
        );

    };

    handleChangePage = (event, newPage) => {

        this.setState(
            {
                page: newPage
            },
            () => {

                this.apicall();

            }
        );

    };

    handleChangeRowsPerPage = (event) => {

        this.setState(
            {

                rowsPerPage: parseInt(event.target.value),
                page: 0

            },
            () => {

                this.apicall();

            }
        );

    };

    formatDate = (dt) => {

        if (!dt) return "";

        return dayjs(dt).format("DD-MM-YYYY");

    };

    render() {

    const {
        reportData,
        order,
        orderBy,
        page,
        rowsPerPage,
        totalRecords,
        loading,
        error,
        dynamicColumns,
        grandTotalAmount
    } = this.state;

    const visibleRows = stableSort(
        reportData,
        getSorting(order, orderBy)
    );

    return (

        <React.Fragment>

            {error !== "" && (
                <Alert severity="error">
                    {error}
                </Alert>
            )}

            {loading && (
                <div style={{ textAlign: "center", padding: 20 }}>
                    <CircularProgress />
                </div>
            )}

            <Paper>

                <TableContainer>

                    <Table>

                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={reportData.length}
                            dynamicColumns={dynamicColumns}
                        />

                        <TableBody>

                            {visibleRows.length === 0 ? (

                                <TableRow>

                                    <TableCell
                                        align="center"
                                        colSpan={
                                            dynamicColumns.length + 3
                                        }
                                    >
                                        No Records Found
                                    </TableCell>

                                </TableRow>

                            ) : (

                                <React.Fragment>

                                    {visibleRows.map((item, index) => (

                                        <TableRow key={index} hover>

                                            <TableCell>
                                                {this.formatDate(item.LabourDate)}
                                            </TableCell>

                                            <TableCell>
                                                {item.ProjectName}
                                            </TableCell>

                                            {dynamicColumns.map(col => (

                                                <TableCell
                                                    key={col}
                                                    align="right"
                                                >
                                                    {item[col]}
                                                </TableCell>

                                            ))}

                                            <TableCell align="right">

                                                <b>
                                                    Rs.{" "}
                                                    {parseFloat(
                                                        item.GrandTotalAmount || 0
                                                    ).toLocaleString("en-IN")}
                                                </b>

                                            </TableCell>

                                        </TableRow>

                                    ))}

                                    <TableRow
                                        style={{
                                            background: "#f5f5f5"
                                        }}
                                    >

                                        <TableCell
                                            colSpan={
                                                dynamicColumns.length + 2
                                            }
                                            align="right"
                                        >
                                            <b>Grand Total</b>
                                        </TableCell>

                                        <TableCell align="right">

                                            <b>
                                                Rs.{" "}
                                                {parseFloat(
                                                    grandTotalAmount
                                                ).toLocaleString("en-IN")}
                                            </b>

                                        </TableCell>

                                    </TableRow>

                                </React.Fragment>

                            )}

                        </TableBody>

                    </Table>

                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={
                        this.handleChangeRowsPerPage
                    }
                />

            </Paper>

        </React.Fragment>

    );

}

}


export class Materials extends Component{

   constructor(props) {
    super(props);

    this.state = {
      projectId: props.projectId || "",
  fromDate: dayjs().startOf("month"),
  toDate: dayjs(),

      reportData: [],
      page: 0,
      rowsPerPage: 100,
      totalRecords: 0,

      loading: false
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.projectId !== this.props.projectId) {
      this.setState(
        {
          projectId: this.props.projectId,
          page: 0
        },
        () => this.loadData()
      );
    }
  }

  loadData = () => {
    const { projectId, page, rowsPerPage, fromDate, toDate } = this.state;
	 const from_date = fromDate? fromDate.format("YYYY-MM-DD"): "";
 const to_date = toDate? toDate.format("YYYY-MM-DD"): "";

    if (!projectId) return;

    this.setState({ loading: true });

    axios
      .get(Serverurl + "ajaxmaterialprocurement.php", {
        params: {
          action: "getmaterialpurchasereport",
          project_id: projectId,
		from_date: from_date,
		to_date: to_date,
          index: page,
          maxrecord: rowsPerPage
        }
      })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];

        this.setState({
          reportData: data,
          totalRecords: data?.[0]?.count || data.length,
          loading: false
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handlePageChange = (event, newPage) => {
    this.setState({ page: newPage }, () => this.loadData());
  };

  handleRowsChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      () => this.loadData()
    );
  };
  
  
  handleSearch = () => {
  this.setState(
    {
      page: 0
    },
    () => this.loadData()
  );
};

  downloadBill = (file) => {
    window.open(Serverurl + "uploads/" + file, "_blank");
  };

  render() {
    const { reportData } = this.state;

    return (
      <Paper>
	  
	  <div className="searchmaster">
	  <ul>

		<li>
		  <p>From Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.fromDate}
				onChange={(value) =>
				  this.setState({
					fromDate: value
				  })
				}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>

		<li>
		  <p>To Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.toDate}
				onChange={(value) =>
				  this.setState({toDate: value})}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>
		
		<li>
		  <p className="searchbutton">
			<Button
			  variant="contained"
			  className={useStyles.submit}
			  onClick={this.handleSearch}
			  endIcon={<SearchIcon />}>
			  Search
			</Button>
		  </p>
		</li>

	  </ul>

	</div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Material</TableCell>
                <TableCell>Vendor</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Bill</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {reportData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Records
                  </TableCell>
                </TableRow>
              ) : (
                reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      {r.PurchaseDate
                        ? dayjs(r.PurchaseDate).format("DD/MM/YYYY")
                        : ""}
                    </TableCell>

                    <TableCell>{r.MaterialName}</TableCell>
                    <TableCell>{r.VendorName}</TableCell>
                    <TableCell>{r.Quantity} {r.unit_name}</TableCell>

                    <TableCell>
                      Rs.{" "}
                      {parseFloat(r.Amount || 0).toLocaleString("en-IN")}
                    </TableCell>

                    <TableCell>
                      {r.BillFile && (
                        <Button
                          size="small"
                          onClick={() => this.downloadBill(r.BillFile)}
                        >
                          View
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={this.state.totalRecords}
            page={this.state.page}
            onPageChange={this.handlePageChange}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleRowsChange}
          />
        </TableContainer>
      </Paper>
    );
  }
}


class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      galleryData: [],
      pageIndex: 0,
      pageSize: 3,
      hasMore: true,

      username: "",
      useremail: "",
   projectId: props.projectId,
      imageViewerVisible: false,
      imageViewerImages: [],
      imageViewerIndex: 0,
	  
	    videoViewerVisible: false,
  selectedVideo: null,
    // IMAGE LIGHTBOX
  lightboxOpen: false,
  lightboxSlides: [],
  lightboxIndex: 0,

  // VIDEO POPUP

    };
  }

  

  componentDidMount() {

    if (this.props.projectId) {

        this.setState(
            { projectId: this.props.projectId },
            () => {
                this.loadUser();
                this.loadGallery();
            }
        );

    }

}
componentDidUpdate(prevProps) {

    if (prevProps.projectId !== this.props.projectId) {

        this.setState(
            {
                projectId: this.props.projectId,
                pageIndex: 0,
                galleryData: []
            },
            () => {
                this.loadGallery();
            }
        );

    }

}



  loadUser = () => {
  const userid = localStorage.getItem("userid");
  if (!userid) return;

  axios
    .get(
      `${Serverurl}/ajaxuser.php?action=usergethead&us_id=${userid}`
    )
    .then((res) => {
      if (res.data?.length) {
        this.setState({
          username: res.data[0].us_name,
          useremail: res.data[0].us_emailid
        });
      }
    });
};
openVideo = (video) => {
  this.setState({
    videoViewerVisible: true,
    selectedVideo: video
  });
};

closeVideo = () => {
  this.setState({
    videoViewerVisible: false,
    selectedVideo: null
  });
};

isVideoFile = (filename) => {
  if (!filename) return false;

  const videoExtensions = [
    ".mp4",
    ".webm",
    ".ogg",
    ".mov",
    ".m4v"
  ];

  const extension = filename
    .substring(filename.lastIndexOf("."))
    .toLowerCase();

  return videoExtensions.includes(extension);
};
loadGallery = () => {
  const { pageIndex, pageSize } = this.state;
const projectId = this.props.projectId;

    if (!projectId) return;   // VERY IMPORTANT

  axios
    .get(
      Serverurl +
        "ajaxgallerytitle.php?action=getallforadmin" +
        "&StartIndex=" + pageIndex +
        "&PageSize=" + pageSize +
        "&projectid=" + projectId
    )
    .then((res) => {
      const rows = res.data || [];

      

    const galleryRows = rows.map((item) => {

  const media = item.images
    ? item.images
        .split("||")
        .filter(Boolean)
        .map((img) => {

          const parts = img.split("|");

          const fileName = parts[1];

          return {
            gl_id: parts[0],
            gl_photo: fileName,
            type: this.isVideoFile(fileName)
              ? "video"
              : "image"
          };
        })
    : [];

  return {
    ...item,
    images: media
  };
});

      this.setState((prev) => ({
        galleryData:
          prev.pageIndex === 0
            ? galleryRows
            : [...prev.galleryData, ...galleryRows],

        hasMore: galleryRows.length >= prev.pageSize
      }));
    });
};




  loadMore = () => {
    this.setState(
      (prev) => ({ pageIndex: prev.pageIndex + 1 }),
      this.loadGallery
    );
  };

 

  openViewer = (images, selectedIndex) => {

  // Only images go into image lightbox
  const imageFiles = images.filter(
    (item) => item.type === "image"
  );

  const selectedImage = images[selectedIndex];

  const lightboxIndex = imageFiles.findIndex(
    (item) => item.gl_id === selectedImage.gl_id
  );

  const slides = imageFiles.map((item) => ({
    src: `${Serverurl}/uploads/${item.gl_photo}`
  }));

  this.setState({
    lightboxOpen: true,
    lightboxSlides: slides,
    lightboxIndex: lightboxIndex >= 0 ? lightboxIndex : 0
  });
};

closeViewer = () => {
  this.setState({
    lightboxOpen: false
  });
};

  /*nextImage = () => {
    this.setState((prev) => ({
      imageViewerIndex:
        prev.imageViewerIndex === prev.imageViewerImages.length - 1
          ? 0
          : prev.imageViewerIndex + 1
    }));
  };

  prevImage = () => {
    this.setState((prev) => ({
      imageViewerIndex:
        prev.imageViewerIndex === 0
          ? prev.imageViewerImages.length - 1
          : prev.imageViewerIndex - 1
    }));
  };

*/

 

  formatDate = (dt) => {
    if (!dt) return "";
    return new Date(dt).toLocaleDateString();
  };

 
  render() {
    const {imageViewerImages,
      imageViewerIndex
    } = this.state;
    
      
      

    return (
      <div className="gallery-page">

       

        
        <div className="gallery-list">

          {this.state.galleryData.length === 0 && (
            <div className="no-record">No Records Found</div>
          )}

          {this.state.galleryData.map((item) => {

  const images = item.images || [];
const media = item.images || [];

const extraCount =
  media.length > 4
    ? media.length - 4
    : 0;

  return (
    <div key={item.glt_id} className="gallery-card">

      <div className="gallery-date">
        {this.formatDate(item.glt_createddate)}
      </div>

      <div className="gallery-title">
        {item.glt_title}
      </div>

      <div className="gallery-grid">

  {media.slice(0, 4).map((file, index) => {

    return (
      <div
        key={file.gl_id}
        className="gallery-image-box"
        onClick={() => {

          if (file.type === "video") {

            this.openVideo(file);

          } else {

            this.openViewer(media, index);

          }

        }}
      >

        {/* IMAGE */}
        {file.type === "image" && (
          <img
            src={`${Serverurl}/uploads/${file.gl_photo}`}
            alt=""
          />
        )}

        {/* VIDEO */}
        {file.type === "video" && (
          <div className="video-thumbnail">

            <video
              src={`${Serverurl}/uploads/${file.gl_photo}`}
              muted
              preload="metadata"
            />

            <div className="video-play-button">
              ▶
            </div>

          </div>
        )}

        {/* + COUNT */}
        {index === 3 && extraCount > 0 && (
          <div className="gallery-overlay">
            +{extraCount}
          </div>
        )}

      </div>
    );

  })}

</div>

      <div className="gallery-user">
        By {item.username}
      </div>

    </div>
  );
})}

        </div>

        {/* LOAD MORE */}
        {this.state.hasMore && (
          <div className="load-more-wrap">
            <button className="load-btn" onClick={this.loadMore}>
              Load More
            </button>
          </div>
        )}

        {/* IMAGE MODAL */}
        <Lightbox
  open={this.state.lightboxOpen}
  close={this.closeViewer}
  index={this.state.lightboxIndex}
  slides={this.state.lightboxSlides}
  plugins={[Zoom, Fullscreen]}

  zoom={{
    maxZoomPixelRatio: 3
  }}

  carousel={{
    finite: false
  }}
/>
		
		
		{this.state.videoViewerVisible &&
  this.state.selectedVideo && (

    <div
      className="video-modal"
      onClick={this.closeVideo}
    >

      <div
        className="video-modal-content"
        onClick={(e) => e.stopPropagation()}
      >

        <button
          className="close-btn"
          onClick={this.closeVideo}
        >
          ×
        </button>

        <video
          className="popup-video"
          controls
          autoPlay
          playsInline
        >
          <source
            src={`${Serverurl}/uploads/${this.state.selectedVideo.gl_photo}`}
            type="video/mp4"
          />

          Your browser does not support video playback.
        </video>

      </div>

    </div>
)}

      </div>
    );
  }
}

class ExpensesReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportData: [],
  fromDate: dayjs().startOf("month"),
  toDate: dayjs(),
      loading: false,
      totalAmount: 0,  page: 0,
  rowsPerPage: 100,
  totalRecords: 0
    };
  }

  componentDidMount() {
    this.fetchReportDataAuto();
  }

  componentDidUpdate(prevProps) {
   
    if (prevProps.projectId !== this.props.projectId) {
      this.fetchReportDataAuto();
    }
  }

 fetchReportDataAuto = () => {
  const projectId = this.props.projectId || "";
  const { page, rowsPerPage, fromDate, toDate } = this.state;
 const from_date = fromDate? fromDate.format("YYYY-MM-DD"): "";
 const to_date = toDate? toDate.format("YYYY-MM-DD"): "";

  this.setState({ loading: true });

  axios
    .get(Serverurl + "ajaxlaborexpensesreport.php", {
      params: {
        action: "getlaborexpensesreport",
        project_id: projectId,
       from_date: from_date,
      to_date: to_date,
        index: page,
        maxrecord: rowsPerPage
      }
    })
    .then((res) => {
      console.log(res.data);

      const data = Array.isArray(res.data) ? res.data : [];

      let totalAmount = 0;
 data.forEach((item) => {
        totalAmount += Number(item.Amount || 0);
    });

      this.setState({
        reportData: data,
       totalAmount,
       totalRecords: data?.[0]?.count || 0,
        loading: false
      });
    })
    .catch((err) => {
      console.log(err);
      this.setState({ loading: false });
    });
};

handlePageChange = (event, newPage) => {
  this.setState(
    {
      page: newPage
    },
    () => this.fetchReportDataAuto()
  );
};




handleRowsChange = (event) => {
  this.setState(
    {
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    },
    () => this.fetchReportDataAuto()
  );
};

handleSearch = (event) => {
  if (event) {
    event.preventDefault();
  }

  this.setState(
    {
      page: 0
    },
    () => {
      this.fetchReportDataAuto();
    }
  );
};

  render() {
    const { reportData, totalAmount } = this.state;
    return (
      <Paper>
	  
	  
	  <div className="searchmaster">
	  <ul>

		<li>
		  <p>From Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.fromDate}
				onChange={(value) =>
				  this.setState({
					fromDate: value
				  })
				}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>

		<li>
		  <p>To Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.toDate}
				onChange={(value) =>
				  this.setState({toDate: value})}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>
		<li>
		  <p className="searchbutton">
			<Button
			  variant="contained"
			  className={useStyles.submit}
			  onClick={this.handleSearch}
			  endIcon={<SearchIcon />}>
			  Search
			</Button>
		  </p>
		</li>

	  </ul>

	</div>

        <TableContainer>

          <Table>

            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Project</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Photo</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell>Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {reportData.length > 0 ? (
                reportData.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      {row.WorkDate
                        ? dayjs(row.WorkDate).format("DD/MM/YYYY")
                        : ""}
                    </TableCell>

                    <TableCell>{row.ProjectName}</TableCell>
                    <TableCell>{row.CategoryName}</TableCell>

                    <TableCell>
                      {row.Photo ? (
                        <img
                          src={`${Serverurl}uploads/${row.Photo}`}
                          alt="img"
                          width="50"
                          height="50"
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    <TableCell>{row.Remarks || "-"}</TableCell>

                    <TableCell>
                      Rs. {parseFloat(row.Amount).toLocaleString("en-IN")}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

              <TableFooter>
  <TableRow>
    <TableCell colSpan={5} align="right">
      <b>Grand Total</b>
    </TableCell>
    <TableCell>
  <b>₹ {totalAmount.toLocaleString("en-IN")}</b>
</TableCell>
    <TableCell />
  </TableRow>
</TableFooter>


          </Table>
	
			<TablePagination
  component="div"
  count={this.state.totalRecords}
  page={this.state.page}
  onPageChange={this.handlePageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.handleRowsChange}
/>
        </TableContainer>

      </Paper>
    );
  }
}


	
  
export class Paymentin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportData: [],
	    fromDate: dayjs().startOf("month"),
  toDate: dayjs(),
      loading: false,
      totalAmount: 0,
      page: 0,
      rowsPerPage: 10,
      totalRecords: 0
    };
  }

  componentDidMount() {
    this.fetchPaymentData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.projectId !== this.props.projectId) {
      this.setState(
        { page: 0 },
        () => this.fetchPaymentData()
      );
    }
  }

  fetchPaymentData = () => {
    const projectId = this.props.projectId || "";
    const { page, rowsPerPage, fromDate,toDate } = this.state;
	 const fromdate = fromDate? fromDate.format("YYYY-MM-DD"): "";
 const todate = toDate? toDate.format("YYYY-MM-DD"): "";

    this.setState({ loading: true });

    axios
      .get(Serverurl + "ajaxpaymentin.php", {
        params: {
          action: "getall",
          pi_pj_id: projectId,
          StartIndex: page,
          PageSize: rowsPerPage,
          sorting: "pi_id desc",
		  fromdate: fromdate,
		  todate: todate
		  
        }
      })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];

        let totalAmount = 0;
        data.forEach((item) => {
          totalAmount += Number(item.pi_amount || 0);
        });

        this.setState({
          reportData: data,
          totalAmount,
          totalRecords: data?.[0]?.count || 0,
          loading: false
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };

  handlePageChange = (event, newPage) => {
    this.setState(
      { page: newPage },
      () => this.fetchPaymentData()
    );
  };

  handleRowsChange = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0
      },
      () => this.fetchPaymentData()
    );
  };
  
  handleSearch = (event) => {
  if (event) {
    event.preventDefault();
  }

  this.setState(
    {
      page: 0
    },
    () => {
      this.fetchPaymentData();
    }
  );
};

  render() {
    const { reportData, totalAmount } = this.state;

    return (
      <Paper>
		<div className="searchmaster">
	  <ul>

		<li>
		  <p>From Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.fromDate}
				onChange={(value) =>
				  this.setState({
					fromDate: value
				  })
				}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>

		<li>
		  <p>To Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.toDate}
				onChange={(value) =>
				  this.setState({toDate: value})}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>
		<li>
		  <p className="searchbutton">
			<Button
			  variant="contained"
			  className={useStyles.submit}
			  onClick={this.handleSearch}
			  endIcon={<SearchIcon />}>
			  Search
			</Button>
		  </p>
		</li>

	  </ul>

	</div>
	  
	  
               <TableContainer sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell >Project</TableCell>
                  <TableCell >Date</TableCell>
				    <TableCell >Amount</TableCell>
                  <TableCell >Mode</TableCell>
				  <TableCell >Remarks</TableCell>
				 		  <TableCell >Bill</TableCell>
				 
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{r.pj_projectname}</TableCell>
                    <TableCell>
                      {r.pi_date
                        ? dayjs(r.pi_date).format("DD/MM/YYYY")
                        : ""}
                    </TableCell>
					 <TableCell>
                     Rs. {parseFloat(r.pi_amount ).toFixed(2)}
                    </TableCell>
                    <TableCell>{r.pi_modename}</TableCell>
					 <TableCell>{r.pi_remarks}</TableCell>
					 <TableCell>
{r.pi_bill!=="" && (
<a href={Serverurl+"uploads/"+r.pi_bill} target="_blank"><FileDownloadIcon /></a>

)}




    </TableCell>
                  </TableRow>
                ))}
				<TableRow > <TableCell colSpan={2} align="right">
      <b>Grand Total</b>
    </TableCell>
    <TableCell>
  <b>₹ {totalAmount.toLocaleString("en-IN")}</b>
</TableCell>
    <TableCell />  </TableRow>
              </TableBody>
			  <TableFooter>
  <TableRow>
    <TableCell colSpan={3}></TableCell>
  </TableRow>
</TableFooter>
            </Table>

					  <TablePagination
  component="div"
  count={this.state.totalRecords}
  page={this.state.page}
  onPageChange={this.handlePageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.handleRowsChange}
/>
          </TableContainer>
      </Paper>
    );
  }
}




export class Services extends Component {
	constructor(props) {
    super(props);

    this.state = {
      projectId: "",
      reportData: [],
      page: 0,
      rowsPerPage: 10,
      totalRecords: 0,
      loading: false
    };
  }
   getProjectIdFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("projectid");
  };
  componentDidMount() {
    const projectId = this.props.projectId || this.getProjectIdFromURL() || "";

    if (projectId) {
      this.setState(
        { projectId, page: 0 },
        () => this.fetchServicemembers()
      );
    }
  }
  fetchServicemembers = () => {
    const { projectId, page, rowsPerPage } = this.state;

    this.setState({ loading: true });

    axios
      .get(Serverurl + "ajaxdailylabor.php", {
        params: {
          action: "getsupervision",
          dl_pj_id: projectId,
          StartIndex: page,
          PageSize: rowsPerPage,userid:"1",
        }
      })
      .then((res) => {
        const data = res.data || [];

        this.setState({
          reportData: data,
          totalRecords: data?.[0]?.count || 0,
          loading: false
        });
      })
      .catch((err) => {
      
        this.setState({ loading: false });
      });
  };
  
  
  handlePageChange = (e, newPage) => {
    this.setState(
      { page: newPage },
      () => this.fetchServicemembers()
    );
  };

  handleRowsChange = (e) => {
    this.setState(
      {
        rowsPerPage: parseInt(e.target.value, 10),
        page: 0
      },
      () => this.fetchServicemembers()
    );
  };
   render() {
    

    return (
      <Paper>
        <TableContainer>
          <Table>

            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Service</TableCell>
              
                <TableCell>Vendor</TableCell>
                <TableCell>Head Count</TableCell>
           
              </TableRow>
            </TableHead>

            <TableBody>
              {this.state.reportData.length > 0 ? (
                this.state.reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      {r.labourdate}
                    </TableCell>
                    <TableCell>{r.se_servicename}</TableCell>
                    <TableCell>{r.vm_vendorname}</TableCell>
                  
                    <TableCell>{r.dld_noofheads}</TableCell>
                   
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>

          <TablePagination
            component="div"
            count={ this.state.totalRecords}
            page={ this.state.page}
            rowsPerPage={ this.state.rowsPerPage}
            onPageChange={this.handlePageChange}
            onRowsPerPageChange={this.handleRowsChange}
          />
        </TableContainer>
      </Paper>
    );
  }
  
}

export class Paymentout extends Component {
	
	
	constructor(props) {
    super(props);

    this.state = {
      projectId: "",
      reportData: [],
	  fromDate: dayjs().startOf("month"),
    toDate: dayjs(),
      page: 0,
      rowsPerPage: 10,
      totalRecords: 0,
      loading: false
    };
  }

  getProjectIdFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("projectid");
  };

  componentDidMount() {
    const projectId = this.props.projectId || this.getProjectIdFromURL() || "";

    if (projectId) {
      this.setState(
        { projectId, page: 0 },
        () => this.fetchReport()
      );
    }
  }



  fetchReport = () => {
    const { projectId, page, rowsPerPage,fromDate, toDate } = this.state;
	const from_date = dayjs(fromDate).format("YYYY-MM-DD");
const to_date = dayjs(toDate).format("YYYY-MM-DD");

    this.setState({ loading: true });

    axios
      .get(Serverurl + "ajaxtransactions.php", {
        params: {
          action: "paymentoutreport",
          projectid: projectId,
		  fromdate: from_date,
		  todate: to_date,
		  
          StartIndex: page,
          PageSize: rowsPerPage
        }
      })
      .then((res) => {
        const data = res.data || [];

        this.setState({
          reportData: data,
          totalRecords: data?.[0]?.count || 0,
          loading: false
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  };

  handlePageChange = (e, newPage) => {
    this.setState(
      { page: newPage },
      () => this.fetchReport()
    );
  };

  handleRowsChange = (e) => {
    this.setState(
      {
        rowsPerPage: parseInt(e.target.value, 10),
        page: 0
      },
      () => this.fetchReport()
    );
  };
  
  handleSearch = () => {
  this.setState(
    {
      page: 0
    },
    () => this.fetchReport()
  );
};

  render() {
    const { reportData, totalRecords, page, rowsPerPage, fromDate, toDate } = this.state;

    return (
      <Paper>
	  
	  <div className="searchmaster">
	  <ul>

		<li>
		  <p>From Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.fromDate}
				onChange={(value) =>
				  this.setState({
					fromDate: value
				  })
				}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>

		<li>
		  <p>To Date</p>

		  <p>
			<LocalizationProvider
			  dateAdapter={AdapterDayjs}
			>
			  <DatePicker
				disableFuture
				format="DD/MM/YYYY"
				value={this.state.toDate}
				onChange={(value) =>
				  this.setState({toDate: value})}
				slotProps={{
				  textField: {
					size: "small",
					fullWidth: true
				  }
				}}
			  />
			</LocalizationProvider>
		  </p>
		</li>
		<li>
		  <p className="searchbutton">
			<Button
			  variant="contained"
			  className={useStyles.submit}
			  onClick={this.handleSearch}
			  endIcon={<SearchIcon />}>
			  Search
			</Button>
		  </p>
		</li>

	  </ul>

	</div>
        <TableContainer>
          <Table>

            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Project</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Vendor</TableCell>
                <TableCell>Mode</TableCell>
                <TableCell align="right">Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {reportData.length > 0 ? (
                reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      {dayjs(r.PaymentDate).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>{r.ProjectName}</TableCell>
                    <TableCell>{r.Category}</TableCell>
                    <TableCell>{r.Particular}</TableCell>
                    <TableCell>{r.PaymentMode}</TableCell>
                    <TableCell align="right">
                      Rs. {parseFloat(r.Amount || 0).toLocaleString("en-IN")}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>

          <TablePagination
            component="div"
            count={totalRecords}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={this.handlePageChange}
            onRowsPerPageChange={this.handleRowsChange}
          />
        </TableContainer>
      </Paper>
    );
  }
}